import moment from "moment";

// This may or may not actually be neccessary... But we're leaving it here as of now
export function formatDateForPostRequest(date) {
  const isMoment = moment.isMoment(date);

  // Some forms don't require a date, so in those cases we're passing along an empty string
  if (!isMoment) {
    return "";
  }

  return date.format();
}



// WEBPACK FOOTER //
// ./src/util/formatDate.js